// eslint-disable-next-line
// @ts-ignore
export function sanitizeRequest<T>(data: T) {
  //we shouldn't sanitize Uint8Array format
  if (data instanceof Uint8Array) {
    return data
  }
  if (typeof data === 'string') {
    return data.trim()
  } else if (Array.isArray(data)) {
    return sanitizeArray(data)
  } else if (typeof data === 'object' && data !== null) {
    const trimmedObj = {}
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        trimmedObj[key] = sanitizeRequest(data[key])
      }
    }
    return trimmedObj as T
  }
  return data as T
}

// eslint-disable-next-line
// @ts-ignore
export function sanitizeArray(arr: Array) {
  if (arr instanceof Uint8Array) {
    return arr
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return arr.map((item) => sanitizeRequest(item))
}
